// extracted by mini-css-extract-plugin
module.exports = {"guideline":"styles-module--guideline--WqnrI","mainTitle":"styles-module--mainTitle--334P1","text":"styles-module--text--1z5Fx","image":"styles-module--image--2NhiM"};